import { PageHeader, Select, Space, Tag, message, Popconfirm, Table, Alert } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SelectItem, DatePickerItem, TableItem, dineroDisabledMask, TourItem } from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { PlayCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

moment.locale("es");

const { Option } = Select;

const FRECUENCIAS = [
  { value: 1, label: "Mensual" },
  { value: 2, label: "Bimestral" },
  { value: 3, label: "Trimestral" },
  { value: 4, label: "Semestral" },
  { value: 5, label: "Anual" },
];

const ESTADOS_CORRIDA = {
  1: { label: "En proceso", color: "blue" },
  2: { label: "Completada", color: "green" },
  3: { label: "Error", color: "red" },
  4: { label: "Sin movimientos", color: "default" },
};

class CorrerDepreciacion extends Component {
  refControles = React.createRef();
  refPreview = React.createRef();
  refCorridas = React.createRef();
  state = {
    loading: false,
    openTour: false,
    frecuencia: 1,
    fechaCorte: moment(),
    preview: null,
    corridas: [],
  };

  componentDidMount() {
    this.consultarCorridas();
  }

  consultarCorridas() {
    axios
      .post("activosFijos/selectCorridasDepreciacion", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({ corridas: res.data });
        }
      });
  }

  verCandidatos() {
    this.setState({ loading: true, preview: null });
    axios
      .post(
        "activosFijos/previsualizarCorridaDepreciacion",
        {
          empresaId: this.props.empresaId,
          frecuencia: this.state.frecuencia,
          fechaCorte: this.state.fechaCorte,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ preview: res.data });
        } else {
          message.error("No se pudo calcular la previsualización");
        }
      });
  }

  confirmarCorrida() {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/ejecutarCorridaDepreciacion",
        {
          empresaId: this.props.empresaId,
          frecuencia: this.state.frecuencia,
          fechaCorte: this.state.fechaCorte,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          // estado 4 = sin movimientos: la corrida se registró pero no había ningún
          // activo por depreciar en el periodo, así que no se generó ninguna póliza.
          if (res.data.corrida?.estado === 4) {
            message.info("No hay activos por depreciar en este periodo");
          } else {
            message.success("Corrida de depreciación generada correctamente");
          }
          this.setState({ preview: null });
          this.consultarCorridas();
        } else {
          message.error(res.data.message || "No se pudo generar la corrida de depreciación");
        }
      });
  }

  render() {
    const columnasPreview = [
      { title: "Activo", dataIndex: "descripcionActivo", key: "descripcionActivo" },
      { title: "Serie / Folio", dataIndex: "serieNumero", key: "serieNumero" },
      { title: "Periodos", dataIndex: "periodosPendientes", key: "periodosPendientes" },
      { title: "Monto a Depreciar", dataIndex: "montoEsteRun", key: "montoEsteRun", render: (v) => dineroDisabledMask(v) },
    ];

    const columnasCorridas = [
      { title: "Periodo", dataIndex: "periodoClave", key: "periodoClave" },
      {
        title: "Frecuencia",
        dataIndex: "frecuenciaProcesada",
        key: "frecuenciaProcesada",
        render: (v) => FRECUENCIAS.find((f) => f.value === v)?.label || "-",
      },
      { title: "Fecha de Corte", dataIndex: "fechaCorte", key: "fechaCorte", render: (v) => moment(v).format("DD/MM/YYYY") },
      { title: "Activos Procesados", dataIndex: "totalActivosProcesados", key: "totalActivosProcesados" },
      { title: "Monto Total", dataIndex: "montoTotalDepreciado", key: "montoTotalDepreciado", render: (v) => dineroDisabledMask(v) },
      {
        title: "Ejecutado por",
        dataIndex: "ejecutadoPor",
        key: "ejecutadoPor",
        render: (v) => (v === 1 ? "Automático (cron)" : "Manual"),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        render: (v) => {
          const config = ESTADOS_CORRIDA[v] || { label: "—", color: "default" };
          return <Tag color={config.color} className="square-tag">{config.label}</Tag>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Correr Depreciación"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <div ref={this.refControles}>
              <Space>
                <SelectItem
                  placeholder="Frecuencia"
                  width={150}
                  value={this.state.frecuencia}
                  onChange={(value) => this.setState({ frecuencia: value, preview: null })}
                >
                  {FRECUENCIAS.map((f) => (
                    <Option value={f.value} key={f.value}>{f.label}</Option>
                  ))}
                </SelectItem>
                <DatePickerItem
                  value={this.state.fechaCorte}
                  onChange={(value) => this.setState({ fechaCorte: value, preview: null })}
                  format="DD/MM/YYYY"
                />
                {this.props.permisoVerCandidatosDepreciacion && (
                  <ButtonItem type="default" icon={<PlayCircleOutlined />} onClick={this.verCandidatos.bind(this)} loading={this.state.loading}>
                    Ver Candidatos
                  </ButtonItem>
                )}
                {this.state.preview && this.state.preview.detalle?.length > 0 && (
                  <Popconfirm
                    title={`¿Confirmar corrida por ${dineroDisabledMask(this.state.preview.montoTotal)} sobre ${this.state.preview.detalle.length} activo(s)?`}
                    onConfirm={this.confirmarCorrida.bind(this)}
                    okText="Si"
                    cancelText="No"
                  >
                    <ButtonItem type="primary" icon={<CheckCircleOutlined />}>
                      Confirmar y Generar Póliza
                    </ButtonItem>
                  </Popconfirm>
                )}
                <ButtonItem type="default" blanco onClick={() => this.setState({ openTour: true })}>
                  ¿Cómo funciona?
                </ButtonItem>
              </Space>
            </div>
          }
        />
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 12 }}
          message="Fórmula de depreciación (Línea Recta)"
          description={
            <span>
              Cada corrida deprecia: <strong>(Costo − Valor Residual) × Depreciación Anual %</strong> entre 12 (depreciación mensual), multiplicado por los meses transcurridos según la frecuencia elegida (Mensual=1, Bimestral=2, Trimestral=3, Semestral=6, Anual=12).
              Solo se incluyen los activos vigentes de la frecuencia y empresa seleccionadas que aún no terminan de depreciarse. Un mismo periodo+frecuencia no puede correrse dos veces.
            </span>
          }
        />
        {this.state.preview && (
          <div ref={this.refPreview}>
            <h4 style={{ marginTop: 10 }}>
              Previsualización — {this.state.preview.totalActivosACalcular} activo(s) a depreciar, {this.state.preview.totalActivosOmitidos} omitido(s), monto total {dineroDisabledMask(this.state.preview.montoTotal)}
            </h4>
            <TableItem
              size="small"
              dataSource={this.state.preview.detalle}
              columns={columnasPreview}
              pagination={false}
              style={{ marginBottom: 20 }}
            />
          </div>
        )}
        <div ref={this.refCorridas}>
          <h4 style={{ marginTop: 10 }}>Corridas Ejecutadas</h4>
          <Table
            size="small"
            dataSource={this.state.corridas}
            columns={columnasCorridas}
            rowKey="_id"
            pagination={{ pageSize: 20 }}
          />
        </div>
        <TourItem
          open={this.state.openTour}
          onClose={() => this.setState({ openTour: false })}
          steps={[
            {
              title: "Correr Depreciación",
              description: "Aquí ejecutas manualmente la corrida periódica de depreciación de tus activos fijos (además, un cron automático la corre diario por si no la corres tú a tiempo).",
              target: null,
            },
            {
              title: "Elegir frecuencia y fecha de corte",
              description: "Elige la frecuencia (mensual, bimestral, etc.) y la fecha hasta la que quieres calcular. Luego 'Ver Candidatos' para previsualizar sin guardar nada todavía.",
              target: () => this.refControles.current,
            },
            {
              title: "Previsualización",
              description: "Muestra qué activos se depreciarían y por cuánto, ANTES de confirmar. Si algo se ve mal, cambia la fecha/frecuencia y vuelve a previsualizar. Nada se guarda hasta que confirmes.",
              target: () => this.refPreview.current,
            },
            {
              title: "Confirmar y Generar Póliza",
              description: "Al confirmar se genera la póliza contable (Cargo a Costo o Gasto, Abono a Depreciación Acumulada) y se actualiza el valor en libros de cada unidad. Un mismo periodo+frecuencia no se puede volver a correr.",
              target: () => this.refControles.current,
            },
            {
              title: "Corridas Ejecutadas",
              description: "Historial de todas las corridas (manuales y automáticas por cron), con su estado, monto total y activos procesados.",
              target: () => this.refCorridas.current,
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoVerCandidatosDepreciacion: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a69548a49a8383de2bd78ca")?.activado,
  };
};

export default connect(mapStateToProps)(CorrerDepreciacion);
